import { Fragment, isValidElement, ReactNode } from 'react'

import { PickerItem } from '../types'
import { reactToString } from '../utils/reactToString'

interface SelectedElementProps<Item extends PickerItem> {
  selectedItems: Item[]
  prefix: (className: string) => string
}

const MAX_VISIBLE_COUNT = 99

const getLabelText = (label: ReactNode) => {
  if (typeof label === 'string' || typeof label === 'number') {
    return label
  }
  if (isValidElement<{ children?: ReactNode }>(label)) {
    return reactToString(label).join('')
  }
  return ''
}

export const SelectedElement = <Item extends PickerItem>({
  selectedItems,
  prefix,
}: SelectedElementProps<Item>) => {
  const count = selectedItems.length
  const title = selectedItems.map(item => getLabelText(item.label)).join(', ')

  return (
    <>
      <span className={prefix('value-list')} title={title}>
        {selectedItems.map((item, index) => (
          <Fragment key={item.value}>
            <span className={prefix('value-item')}>{item.label}</span>
            {index === count - 1 ? null : <span className={prefix('value-separator')}>,</span>}
          </Fragment>
        ))}
      </span>
      <span className={prefix('value-count')} title={`${count}`}>
        {count > MAX_VISIBLE_COUNT ? `${MAX_VISIBLE_COUNT}+` : count}
      </span>
    </>
  )
}
